var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 62,
    viewBox: "0 0 74 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08637 26.3165C24.9543 17.6904 38.1996 12.0034 44.8223 9.25533C63.7533 1.40926 67.6822 0.0465681 70.2482 0.000402251C70.8125 -0.00861867 72.0689 0.130408 72.8887 0.791058C73.5702 1.34823 73.7618 2.10175 73.8576 2.6308C73.9428 3.15932 74.0599 4.36388 73.9641 5.30417C72.942 16.0444 68.502 42.1074 66.2448 54.1371C65.2972 59.227 63.4126 60.9335 61.5919 61.1001C57.6311 61.4631 54.6285 58.4936 50.7955 55.9901C44.801 52.0707 41.4151 49.6319 35.591 45.8081C28.8619 41.3889 33.2273 38.9596 37.0604 34.9904C38.0612 33.9514 55.5016 18.1436 55.8317 16.7098C55.8743 16.5304 55.9169 15.8618 55.5123 15.5095C55.1183 15.1561 54.5327 15.2771 54.1068 15.3726C53.4999 15.5084 43.9279 21.8209 25.3589 34.3091C22.6439 36.1706 20.1843 37.078 17.9697 37.0302C15.5421 36.9782 10.8572 35.659 7.37556 34.5319C3.11662 33.1491 -0.279893 32.4179 0.0182327 30.0692C0.167296 28.8466 1.86023 27.5954 5.08637 26.3165Z",
    fill: "#2AABEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.c82a35fafd5e7abc1cc162b4e9aeaf84.svg";
export { ForwardRef as ReactComponent };